import { Routes } from '@angular/router';
export const PRIVATE_ROUTES: Routes = [
    { path: 'dashboard', loadChildren:'./dashboard/dashboard.module#DashboardModule'},
    { path: 'sales', loadChildren: './sales-rep/sales-rep.module#SalesRepModule' },
    { path: 'retailer-details', loadChildren: './retailer-detail/retailer-detail.module#RetailerDetailModule' },
    { path: 'retailers', loadChildren: './retailer/retailer.module#RetailerModule' },
    { path: 'profile', loadChildren: './profile/profile.module#ProfileModule' },
    { path: 'product', loadChildren:'./suggest-products/suggest-products.module#SuggestProductsModule'},
    { path: 'closed-store', loadChildren:'./closed-store/closed-store.module#ClosedStoreModule'},
];
